import { render } from "./PersonalPhotography.vue?vue&type=template&id=099d7c6c&scoped=true"
import script from "./PersonalPhotography.vue?vue&type=script&lang=js"
export * from "./PersonalPhotography.vue?vue&type=script&lang=js"

import "./PersonalPhotography.vue?vue&type=style&index=0&id=099d7c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099d7c6c"]])

export default __exports__